import React, { useEffect, useMemo, useCallback } from 'react';
import { CdsDropdownControl } from 'clayco-component-library';
import ApiProvider from '../apiProvider';
import { useMsal } from "@azure/msal-react";
import { useState } from 'react';
import { useEmployeeNumber } from '../employeeNumber';
import { Spinner } from "react-bootstrap";

const OnBehalfOfControl = ({ children }) => {
    const { instance, accounts } = useMsal();
    const apiProvider = useMemo(() => new ApiProvider(instance, accounts[0]), [instance, accounts]);
    const { employeeNumber, setEmployeeNumber } = useEmployeeNumber();
    const [array, setArray] = useState([]);
    const [loading, setLoading] = useState(true);

    const getOboUsers = useCallback(async () => {
        let result = await apiProvider.Get(
            `OnBehalfOf/GetByUser`,
            null,
            "application/json",
            false
        );
        var fullData = result[0]?.users;
        let additionalData;

        if (fullData) {
            const user = result[0];
            additionalData = {
                employeeNumber: String(user.employeeNumber),
                employeeName: user.employeeName,
            };
        } else {
            additionalData = {
                employeeNumber: employeeNumber.number,
                employeeName: employeeNumber.name,
            };
        }

        const formattedOboUsers = [additionalData];
        if (fullData) {
            formattedOboUsers.push(
                ...Object.entries(fullData).map(([id, details]) => ({
                    employeeNumber: id,
                    ...details,
                }))
            );
        }
        setArray(formattedOboUsers);
        setLoading(false);
    }, [apiProvider, employeeNumber]);

    useEffect(() => {
        if (array.length === 0) {
            getOboUsers();
        }
    }, [array, getOboUsers]);

    const onEmployeeSelected = (event) => {
        console.log("Employee Selected: ", event.target.selectedOptions[0].text);
        setEmployeeNumber({
            number: event.target.selectedOptions[0].value,
            name: event.target.selectedOptions[0].text,
        });
    };

    return (
        <>
            {loading ? (
                <div className="spinner">
                    <Spinner></Spinner>
                    <p>Loading...</p>
                </div>
            ) : (
                <div className="d-flex mb-2" style={{ backgroundColor: 'rgb(234, 170, 0)' }}>
                    <div className="d-flex flex-column m-3" style={{ flexGrow: 0.4 }}>
<CdsDropdownControl
    key={employeeNumber.number} // Force remount when employee changes
    label="Edit On-Behalf-Of"
    options={array}
    optionValueField="employeeNumber"
    optionTextField="employeeName"
    onChange={onEmployeeSelected}
    defaultValue={employeeNumber.number} // Will now be applied correctly
/>
                    </div>
                </div>
            )}
            {children /* Render children directly without memoization */}
        </>
    );
};

export default React.memo(OnBehalfOfControl);